import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
// Checkout destination
const CHECKOUT_STANDARD = 'http://checkout.de0aexperto.shop/cart/50664462581927:1';
export function PricingSelector() {
  const handleBuy = () => {
    window.location.href = CHECKOUT_STANDARD;
  };
  return <div className="w-full max-w-md mx-auto" data-id="element-213">
      {/* Plan card */}
      <div className="bg-navy-900/50 border border-navy-700 rounded-2xl p-4 sm:p-6 mb-5 sm:mb-6 text-center" data-id="element-214">
        <h4 className="text-lg sm:text-xl md:text-2xl font-display text-gold-400 uppercase tracking-wide mb-1 sm:mb-2" data-id="element-215">
          KIT DOMINIO TOTAL
        </h4>
        <p className="text-xs sm:text-sm md:text-base text-offwhite font-medium mb-3 sm:mb-4" data-id="element-216">
          3 Tomos + 3 Bonos estratégicos
        </p>

        <div className="flex flex-col items-center justify-center" data-id="element-217">
          <span className="text-lg sm:text-2xl text-text-secondary line-through font-display decoration-red-500/50 decoration-2" data-id="element-218">
            $49.990
          </span>
          <span className="text-5xl sm:text-6xl md:text-7xl font-display text-offwhite leading-none" data-id="element-219">
            $19.990{' '}
            <span className="text-xl sm:text-2xl text-gold-500" data-id="element-220">ARS</span>
          </span>
        </div>
      </div>

      {/* CTA button */}
      <div className="relative inline-block w-full" data-id="element-221">
        <motion.div animate={{
        scale: [1, 1.02, 1],
        opacity: [0.3, 0.6, 0.3]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} className="absolute inset-0 bg-gold-500 rounded-xl blur-md" data-id="element-222" />
        <button onClick={handleBuy} className="relative w-full bg-gold-500 hover:bg-gold-400 text-offwhite font-display text-xl sm:text-2xl md:text-3xl py-3 sm:py-4 md:py-5 px-4 sm:px-8 rounded-xl shadow-[0_0_20px_rgba(220,38,38,0.4)] transition-all hover:scale-[1.02] active:scale-95 uppercase tracking-wide mb-4 sm:mb-6" data-id="element-223">
          💥 QUIERO DOMINAR LA MESA AHORA
        </button>
      </div>

      {/* Trust badges */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4 text-[10px] sm:text-xs md:text-sm text-text-secondary font-medium" data-id="element-224">
        <div className="flex items-center justify-center gap-1 sm:gap-1.5" data-id="element-225">
          <ShieldCheckIcon className="w-3 h-3 sm:w-4 sm:h-4 text-green-500" data-id="element-226" />{' '}
          Pago seguro
        </div>
        <div className="flex items-center justify-center gap-1 sm:gap-1.5" data-id="element-227">
          <LockIcon className="w-3 h-3 sm:w-4 sm:h-4 text-green-500" data-id="element-228" /> Acceso
          en 5 min
        </div>
        <div className="flex items-center justify-center gap-1 sm:gap-1.5" data-id="element-229">
          <ShieldCheckIcon className="w-3 h-3 sm:w-4 sm:h-4 text-green-500" data-id="element-230" />{' '}
          Garantía 7 días
        </div>
        <div className="flex items-center justify-center gap-1 sm:gap-1.5" data-id="element-231">
          <CreditCardIcon className="w-3 h-3 sm:w-4 sm:h-4 text-blue-400" data-id="element-232" />{' '}
          Mercado Pago
        </div>
      </div>
    </div>;
}